import { FC } from 'react';
import { useIntl } from 'react-intl';
import { useLocation, useNavigate } from 'react-router-dom';
import { noop } from 'lodash';
import { ParsedQuery } from 'query-string';
import { Button } from '@ebsco-ui/ebsco-ui';

import { generateRouteParams } from '@app/utils';
import { sharedMessages } from '@app/translations';
import { ROUTE } from '@app/constants';

interface ButtonWithRedirectProps {
  redirectBackRoute?: string;
  queryParams?: ParsedQuery;
  onClick?: () => void;
}

export const RedirectToLoginButton: FC<ButtonWithRedirectProps> = ({
  redirectBackRoute,
  queryParams = {},
  onClick = noop,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { $t } = useIntl();

  return (
    <Button
      role="link"
      styleType="default"
      onClick={() => {
        navigate(
          generateRouteParams({
            pathname: ROUTE.login,
            query: {
              redirect: redirectBackRoute ?? location.pathname,
              ...queryParams,
            },
          })
        );
        onClick();
      }}
    >
      {$t(sharedMessages.signIn)}
    </Button>
  );
};
